export default "__VITE_ASSET__I3i28EIG__"